module.exports = __webpack_public_path__ + "static/media/american-express-card.654c73e2.svg";